import { READ_ONLY_SCHEDULE_IDS } from '@/config/schedule';

export function isReadOnlySchedule(scheduleId: string): boolean {
  return READ_ONLY_SCHEDULE_IDS.includes(scheduleId);
}
